var map = {
	"./chocolate-fictional/product_identification.json": [
		6091,
		[
			6091
		]
	],
	"./chocolate/product_identification.json": [
		3055,
		[
			3055
		]
	],
	"./hemas-clogard/product_identification.json": [
		450,
		[
			450
		]
	],
	"./linqOne/product_identification.json": [
		7103,
		[
			7103
		]
	],
	"./munchee-tikiri-marie/product_identification.json": [
		8706,
		[
			8706
		]
	],
	"./shan-teas/product_identification.json": [
		5165,
		[
			5165
		]
	],
	"./wipotech-chocolates/product_identification.json": [
		6652,
		[
			6652
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3294;
module.exports = webpackAsyncContext;